import { Component } from '@angular/core';
import {environment} from "../environments/environment";

@Component({
  selector: 'kis-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'tenova-workflow-editor';

  constructor() {
    console.log(`Running on environment: ${environment.env}`);
  }
}
